import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, fontSizes, mediumTopShadow, spacing, WebLink } from 'ui/theme';
import { SecondaryButton } from 'ui/button';
import { Tileset } from 'ui/icons';

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > * {
    &:not(:first-child) {
      margin-left: ${spacing.threeQuarter};
    }
  }
`;

export const NodeSelectionActions = styled.div`
  display: flex;
  width: 100%;

  & > * {
    flex: 1;
  }
`;

export const FloatingActionsWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const FooterBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  border-radius: ${spacing.quarter};

  height: ${pxToRem(60)};
  padding: ${spacing.threeQuarter};
  background-color: ${colors.white};
  ${mediumTopShadow};
`;

export const NodeFooterBar = styled(FooterBar)`
  justify-content: center;
`;

export const NotesButton = styled(SecondaryButton)`
  && {
    padding-left: ${spacing.half};
    padding-right: ${spacing.half};
    color: ${colors.textSecondary};
    user-select: none;
    svg {
      margin-right: ${spacing.half};
      path {
        stroke: ${colors.textSecondary};
      }
    }
  }
`;

export const SelectedNodesText = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  flex: 1;
  margin-left: ${spacing.quarter};
  color: ${colors.secondaryText};
  font-size: ${fontSizes.s12};

  span {
    margin-left: ${spacing.quarter};
  }
`;

export const StyledLink = styled(WebLink)`
  font-size: ${fontSizes.s14};
  line-height: ${fontSizes.s20};
`;

export const StyledTilesetsBar = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing.quarter};

  > button {
    flex-shrink: 0;
  }
`;

export const TilesetIcon = styled(Tileset)`
  margin-left: ${spacing.quarter};
  margin-right: ${spacing.half};
`;

export const DeleteWrapper = styled.div`
  justify-content: flex-end;
  display: flex;
`;
